import { render, staticRenderFns } from "./RestaurantSidebar.vue?vue&type=template&id=69dc1a1c&scoped=true&"
import script from "./RestaurantSidebar.vue?vue&type=script&lang=js&"
export * from "./RestaurantSidebar.vue?vue&type=script&lang=js&"
import style0 from "./RestaurantSidebar.vue?vue&type=style&index=0&id=69dc1a1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69dc1a1c",
  null
  
)

export default component.exports